var render = function render(){var _vm=this,_c=_vm._self._c;return _c('box',{ref:_vm.boxRef,attrs:{"customer":true,"autoLoad":true,"title":"选择产品","width":800,"index":0,"moduleName":"proofbill","store":_vm.store,"selectType":"checkbox"},on:{"hide":_vm.hide,"submit":_vm.submit,"boxdataload":_vm.boxdataload}})
}
var staticRenderFns = []

export { render, staticRenderFns }